import Layout from 'components/Layout';
import News from 'components/News';
import { compareDesc, format, isBefore, isEqual, parse } from "date-fns";
import SEO from 'components/seo';
import React, { useEffect, useState } from "react";
import PageNation from 'components/PageNation';
import Style from 'styles/components/news.module.scss';
import { useLocation } from "@reach/router";

import { news_endpoint } from "src/constants";

const ITEMS_PER_PAGE = 10;

const fetchNews = () => {
  return fetch(news_endpoint, { cache: "no-store" });
};

const useNews = () => {
  const [news, setNews] = useState([]);
  useEffect(() => {
    fetchNews()
      .then(res => res.json())
      .then(json => {
        if (!json) {
          setNews([]);
          return;
        }
        let items = json.map(item => {
          const date = parse(item.publishDate, "yyyy/MM/dd HH:mm:ss", new Date());
          item.publishDate = date;
          return item;
        });

        const now = new Date();
        items = items.filter(item => isEqual(item.publishDate, now) || isBefore(item.publishDate, now));

        items = items.sort((a, b) => compareDesc(a.publishDate, b.publishDate));

        items = items.map(item => {
          item.publishDate = format(item.publishDate, "yyyy/MM/dd");
          return item;
        });

        setNews(items);
      })
      .catch(e => {
        console.error(e);
        setNews([]);
      });
  }, []);
  return news;
};

const NewsPage = () => {
  const news = useNews();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get("page"));
  const currentPage = isNaN(page) || page < 1 ? 1 : page;

  const totalPages = Math.ceil(news.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentNews = news.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <Layout>
      <SEO title="comachicart" path="news" />
      <News news={currentNews} />
      {totalPages > 1 && (
        <div className={Style.pagenation}>
          <PageNation
            page="/news"
            currentPage={currentPage}
            totalPages={totalPages}
          />
        </div>
      )}
    </Layout>
  );
};

export default NewsPage;
